module.exports = __webpack_public_path__ + "static/media/64-iveco-mercedes.a5e0d95c.jpg";